<ng-container *ngIf="RecordType==AllTableRecordType.OtherAffectedCustodian">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Designation</th>
        <th>Date</th>
        <th>Remark</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="gasTestRecord">
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.username}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.designation" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.designation}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="gasTestRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
                hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.date | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <textarea cols="8" [(ngModel)]="gasTestRecord.Remarks" required></textarea>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.Remarks}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td style="text-align:center">
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && (gasTestRecord.user == loggedInUserJSON.UserId || Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(gasTestRecord)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton type="button" icon="pi pi-trash"
            (click)="onRowDeleteInit(ri,AllTableRecordType.OtherAffectedCustodian)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && (gasTestRecord.user == loggedInUserJSON.UserId || Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            (click)="onRowEditSave(gasTestRecord,ri,AllTableRecordType.OtherAffectedCustodian)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="addRecords">
    <input type="button" class="btn btn-link" (click)="OAFDialog = true" value="Add Record">
  </div>
  <div>
  </div>
  <p-dialog [(visible)]="OAFDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">
    <div class="p-field">
      <label>Affected Custodian Name</label>
      <p-autoComplete [(ngModel)]="SelectedOACUser.UserName" [suggestions]="OACUserSuggestion" appendTo="body"
        (completeMethod)="getUsersOnSearch($event)" placeholder="Employee Name" field="FullName" [minLength]="1"
        (onSelect)="selectUser($event)" (onChange)="selectUser($event)" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}" [forceSelection]="true">
      </p-autoComplete>
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.OtherAffectedCustodian,true)"
        [disabled]="!SelectedOACUser.UserId"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
        (click)="OAFDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
<ng-container *ngIf="RecordType==AllTableRecordType.SafetyCoordination">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Date</th>
        <th>Remark</th>
        <th>Approval</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="gasTestRecord">

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.username}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="gasTestRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
                hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.date | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="gasTestRecord.Remarks" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.Remarks}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="approvals" appendTo="body" [(ngModel)]="gasTestRecord.IsApproved"
                placeholder="Select">
              </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div *ngIf="gasTestRecord.IsApproved == true">Approved</div>
              <div *ngIf="gasTestRecord.IsApproved == false">Rejected</div>
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(gasTestRecord)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri,AllTableRecordType.SafetyCoordination)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing &&  (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            (click)="onRowEditSave(gasTestRecord,ri,AllTableRecordType.SafetyCoordination)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="addRecords">
    <input type="button" class="btn btn-link" (click)="SafetyCoordinatorDialog = true" value="Add Record">
  </div>
  <div>

  </div>
  <p-dialog [(visible)]="SafetyCoordinatorDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">
    <div class="p-field">
      <label>Date</label>
      <div class="p-calendar">
        <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
          [(ngModel)]="inputRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
          hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
        </p-calendar>
      </div>
    </div>
    <div class="p-field">
      <label>Remark</label>
      <input type="text" pInputText [(ngModel)]="inputRecord.Remarks" />
    </div>

    <ng-template pTemplate="footer">
      <button pButton pRipple label="Approve" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.SafetyCoordination,true)"></button>
      <button pButton pRipple [disabled]="(inputRecord.Remarks == undefined || inputRecord.Remarks == '')"
        label="Reject" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.SafetyCoordination,false)"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
        (click)="SafetyCoordinatorDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
<ng-container *ngIf="RecordType==AllTableRecordType.Validation">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Name of Area Authority</th>
        <th>Validated From</th>
        <th>Validated To</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="gasTestRecord">
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.username}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="inputRecord.ValidationTimeFrom" readonlyInput="true" required #timeOfUse="ngModel"
                appendTo="body" hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true"
                yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.ValidationTimeFrom | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="inputRecord.ValidationTimeTo" readonlyInput="true" required #timeOfUse="ngModel"
                appendTo="body" hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true"
                yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.ValidationTimeTo | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(gasTestRecord)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri,AllTableRecordType.Validation)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            (click)="onRowEditSave(gasTestRecord,ri,AllTableRecordType.Validation)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="addRecords">
    <input type="button" class="btn btn-link" (click)="ValidationDialog = true" value="Add Record">
  </div>
  <div>

  </div>
  <p-dialog [(visible)]="ValidationDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">

    <div class="p-field">
      <label>Validated From: </label>
      <div class="p-calendar">
        <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
          [(ngModel)]="inputRecord.ValidationTimeFrom" required readonlyInput="true" #timeOfUse="ngModel" appendTo="body"
          hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
        </p-calendar>
      </div>
    </div>
    <br>
    <div class="p-field">
      <label>Validated To: </label>
      <div class="p-calendar">
        <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
          [(ngModel)]="inputRecord.ValidationTimeTo" required readonlyInput="true" #timeOfUse="ngModel" appendTo="body"
          hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
        </p-calendar>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Validate" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.Validation,true)"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
        (click)="ValidationDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
<ng-container *ngIf="RecordType==AllTableRecordType.Acceptance">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Designation</th>
        <th>Date</th>
        <th>Remark</th>
        <th>Acceptance</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="gasTestRecord">

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.username}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.designation" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.designation}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="gasTestRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
                hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.date | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="gasTestRecord.Remarks" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.Remarks}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="acceptance" appendTo="body" [(ngModel)]="gasTestRecord.IsApproved"
                placeholder="Select">
              </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div *ngIf="gasTestRecord.IsApproved == true">Accepted</div>
              <div *ngIf="gasTestRecord.IsApproved == false">Rejected</div>
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(gasTestRecord)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri,AllTableRecordType.Acceptance)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            (click)="onRowEditSave(gasTestRecord,ri,AllTableRecordType.Acceptance)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="addRecords">
    <input type="button" class="btn btn-link" (click)="AcceptanceDialog = true" value="Add Record">
  </div>
  <div>

  </div>
  <p-dialog [(visible)]="AcceptanceDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">
    <div class="p-field">
      <label>Date</label>
      <div class="p-calendar">
        <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
          [(ngModel)]="inputRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
          hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
        </p-calendar>
      </div>
    </div>
    <div class="p-field">
      <label>Remark</label>
      <input type="text" pInputText [(ngModel)]="inputRecord.Remarks" />
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Accept" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.Acceptance,true)"></button>
      <button pButton pRipple label="Reject"
        [disabled]="(inputRecord.Remarks == undefined || inputRecord.Remarks == '')" icon="pi pi-check"
        class="p-button-text" (click)="saveRecord(AllTableRecordType.Acceptance,false)"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
        (click)="AcceptanceDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
<ng-container *ngIf="RecordType==AllTableRecordType.Suspension">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Date</th>
        <th>Remark</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="gasTestRecord">

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.username}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [disabled]="true" hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="gasTestRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
                hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.date | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="gasTestRecord.Remarks" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{gasTestRecord.Remarks}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(gasTestRecord)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri,AllTableRecordType.Suspension)"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))"
            pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            (click)="onRowEditSave(gasTestRecord,ri,AllTableRecordType.Suspension)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="addRecords">
    <input type="button" class="btn btn-link" (click)="SuspensionDialog = true" value="Add Record">
  </div>
  <div>
  </div>
  <p-dialog [(visible)]="SuspensionDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">
    <div class="p-field">
      <label>Date</label>
      <div class="p-calendar">
        <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
          [(ngModel)]="inputRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
          hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
        </p-calendar>
      </div>
    </div>
    <div class="p-field">
      <label>Remark</label>
      <input type="text" pInputText [(ngModel)]="inputRecord.Remarks" />
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Suspend" icon="pi pi-check" class="p-button-text"
        (click)="saveRecord(AllTableRecordType.Suspension,true)"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
        (click)="SuspensionDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
<ng-container *ngIf="RecordType==AllTableRecordType.TRICTalk">
  <p-table [scrollable]="true" scrollHeight="200px" [value]="TRICinputRecords" dataKey="id" editMode="row">
    <ng-template pTemplate="header">
      <tr>
        <th>Date</th>
        <th>Name of TBT Leader</th>
        <th>No of Work Party</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tricRecords let-editing="editing" let-ri="rowIndex">
      <tr>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
                [(ngModel)]="tricRecords.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
                hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
              </p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{tricRecords.date | date: 'dd/MM/yyyy hh:mm a'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="tricRecords.username" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{tricRecords.username}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" disabled [(ngModel)]="tricRecords.NoOfWorkParty" required>
            </ng-template>
            <ng-template pTemplate="output">
              {{tricRecords.NoOfWorkParty}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <button pButton type="button" icon="pi pi-eye" (click)="viewTRICRecordDetails(ri)"
            class="p-button-rounded p-button-text"></button>
          <button pButton
            *ngIf="lastValue < tricRecords.id || (lastValue >= tricRecords.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit))"
            type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri,AllTableRecordType.TRICTalk)"
            class="p-button-rounded p-button-text"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <input *ngIf="addRecords" type="button" class="btn btn-link" (click)="EmptyTRICRecord()" value="Add Record">
  </div>

  <p-dialog [(visible)]="TRICDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true">
    <div class="p-field">
      <label>Name of TBT Leader :</label>
      {{loggedInUserJSON.FullName}}
    </div>
    <div class="p-field">
      <label for="workPartyCount">Number of Work Party :</label>
      <input name="workPartyCount" id="workPartyCount" type="number" pInputText style="width: auto;" step="1" [(ngModel)]="TRICinputRecord.NoOfWorkParty" />
    </div>
    <p-messages *ngIf="TRICinputRecord.Attendee.length" [(value)]="tricNote"></p-messages>
    <p-table [scrollable]="true" scrollHeight="200px" [value]="TRICinputRecord.Attendee" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th>SrNo</th>
          <th>Attendee Name</th>
          <th>Position</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-attendeeRecords let-ri="rowIndex">
        <tr>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{ri+1}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" placeholder="Enter Name" [(ngModel)]="attendeeRecords.AttendeeName"
                  required>
              </ng-template>
              <ng-template pTemplate="output">
                {{attendeeRecords.AttendeeName}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" placeholder="Enter Position"
                  [(ngModel)]="attendeeRecords.AttendeePosition" required>
              </ng-template>
              <ng-template pTemplate="output">
                {{attendeeRecords.AttendeePosition}}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <ng-container *ngIf="addRecords">
      <button pButton [disabled]="!(TRICinputRecord.NoOfWorkParty > 0) || TRICinputRecord.Attendee.length >= TRICinputRecord.NoOfWorkParty" label="Add Record" icon="pi pi-plus" class="p-button-text" (click)="EmptyTricRecord()"></button>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text"
          [disabled]="(TRICinputRecord.NoOfWorkParty == undefined || TRICinputRecord.NoOfWorkParty == '') || TRICinputRecord.Attendee.length <= 0"
          (click)="saveRecord(AllTableRecordType.TRICTalk,true)"></button>
          <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
            (click)="TRICDialog = false"></button>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="!addRecords">
      <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
              (click)="TRICDialog = false"></button>
      </ng-template>
    </ng-container>
  </p-dialog>
  <p-dialog [(visible)]="AttendeeDialog" (onHide)="closePopUp()" header="Add Records" [modal]="true">
    <form [formGroup]="attendeeFormGroup">
    <div formArrayName="attendeeArray">
      <table>
        <thead>
        <tr>
          <th style="width: 100px; text-align: center;">No</th>
          <th style="width: 400px; text-align: center;">Attendee Name <span class="mandatory">*</span></th>
          <th style="width: 400px; text-align: center;">Attendee Position <span class="mandatory">*</span></th>
        </tr>
      </thead>
      <tbody>
        <tr [formGroupName]="i" *ngFor="let customerGroup of attendeeFormGroup.controls.attendeeArray.controls; let i = index">
          <td style="width: 100px; text-align: center;">{{TRICinputRecord.Attendee.length+i+1}}</td>
          <td style="width: 400px;"><input pInputText type="text" formControlName="attendeeName"/></td>
          <td style="width: 400px;"><input pInputText type="text" formControlName="attendeePosition"/></td>
        </tr>
        <tbody>
      </table>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Save" [disabled]="!attendeeFormGroup.valid || !attendeeFormGroup.touched || !attendeeFormGroup.dirty" icon="pi pi-check"
      class="p-button-text" (click)="saveAttendeeRecord(attendeeFormGroup.controls.attendeeArray.controls)"></button>
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
      (click)="AttendeeDialog = false"></button>
    </ng-template>
  </p-dialog>
</ng-container>
